import { render, staticRenderFns } from "./GiftAwayTransaction.vue?vue&type=template&id=72e789ee"
import script from "./GiftAwayTransaction.vue?vue&type=script&lang=js"
export * from "./GiftAwayTransaction.vue?vue&type=script&lang=js"
import style0 from "./GiftAwayTransaction.vue?vue&type=style&index=0&id=72e789ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports